<p-dialog
  [header]="isEditing ? 'Edit license' : 'Add license'"
  modal
  [(visible)]="isOpen"
  [style]="{ width: '20rem' }"
  (onHide)="closeModal()"
>
  <form
    class="license-form"
    [formGroup]="formGroup"
    #licenseForm="ngForm"
    (ngSubmit)="onSubmitLicense(licenseForm)"
  >
    <div class="form-group">
      <p-floatlabel>
        <input
          pInputText
          type="text"
          name="name"
          inputId="name"
          formControlName="name"
          fluid
        />
        <label for="name">License name</label>
      </p-floatlabel>
    </div>
    <div class="form-group">
      <p-floatlabel>
        <input
          pInputText
          type="text"
          name="address"
          inputId="address"
          formControlName="address"
          fluid
        />
        <label for="address">License address</label>
      </p-floatlabel>
    </div>
    <div class="form-group">
      <p-floatlabel>
        <input
          pInputText
          type="text"
          name="authAddress"
          inputId="authAddress"
          formControlName="authAddress"
          fluid
        />
        <label for="authAddress">License auth address</label>
      </p-floatlabel>
    </div>
    <div class="form-group">
      <p-floatlabel>
        <p-select
          formControlName="status"
          [options]="statusOptions"
          optionLabel="name"
          inputId="status"
          fluid
          appendTo="body"
        ></p-select>
        <label for="status">Status</label>
      </p-floatlabel>
    </div>

    <div class="form-actions">
      <p-button
        label="Cancel"
        variant="text"
        severity="secondary"
        (click)="closeModal()"
      ></p-button>
      <p-button
        type="submit"
        label="Save"
        [disabled]="!licenseForm.valid"
        raised
      ></p-button>
    </div>
  </form>
</p-dialog>
